<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout
        :class="`mx-0 ${!isMobile && 'mt-3'}`"
        row
        wrap
        justify-center
      >
        <v-progress-circular
          v-if="!dataLoaded"
          :width="10"
          color="primary"
          size="100"
          indeterminate
        />
        <v-container>
          <h2 :class="`mb-5 text-xs-center ${headline}`">
            案件の検索
          </h2>
          <v-layout :column="breakpoint.sm || breakpoint.xs">
            <v-flex
              md6
              offset-md3
            >
              <search-form
                :phone="phone"
                :fio="fio"
                :date-from="dateFrom"
                :date-to="dateTo"
                :inspection-type="inspectionType"
                :id="id"
                class="mb-5"
                @loaded="onLoaded"
              />
            </v-flex>
          </v-layout>
          <template v-if="showResults">
            <h2 class="headline mb-3">検索結果</h2>
            <appointments-list
              :appointments="appointments"
              :server-time="serverTime"
            />
            <div class="text-xs-right mt-3">
              <v-btn
                color="primary"
                outline
                small
                class="mx-0"
                @click="() => scrollTo(null, 300)"
              >トップへ</v-btn>
            </div>
          </template>
        </v-container>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import SearchForm from '../components/forms/SearchForm';
  import AppointmentsList from '../components/AppointmentsList';

  export default {
    components: {
      SearchForm,
      AppointmentsList,
    },
    metaInfo: {
      title: '検索',
    },
    props: {
      phone: {
        type: String,
        default: null,
      },
      fio: {
        type: String,
        default: null,
      },
      dateFrom: {
        type: String,
        default: null,
      },
      dateTo: {
        type: String,
        default: null,
      },
      inspectionType: {
        type: String,
        default: null,
      },
      id: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dataLoaded: true,
        showResults: false,
        appointments: [],
        serverTime: 0,
      };
    },
    mounted() {
      this.$nextTick(() => window.scrollTo(0, 0));
    },
    methods: {
      onLoaded(appointments, serverTime) {
        this.appointments = appointments || [];
        this.serverTime = serverTime;
        this.showResults = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/SearchPage.vue